module.exports = __webpack_public_path__ + "img/caret-icon.801ecb49.svg";